// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".match-search-group-icon{width:20px;height:20px}", "",{"version":3,"sources":["webpack://./src/components/candidate/profile/section/matched-search-group-icon/style.scss"],"names":[],"mappings":"AAAA,yBACI,UAAA,CACA,WAAA","sourcesContent":[".match-search-group-icon {\n    width: 20px;\n    height: 20px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
